import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';

import { appendScript } from '@ovpn-ui/utils';

import { PageLoader } from './components/PageLoader';

const LazyRoot = React.lazy(() => import('./root.component'));

function LazyRootCmp() {
    return (
        <Suspense fallback={<PageLoader delayed withSidebarOffset />}>
            <LazyRoot />
        </Suspense>
    );
}

const {
    bootstrap: bootstrapOriginal,
    mount,
    unmount,
} = singleSpaReact({
    React,
    // @ts-expect-error dynamic support for react 17/18
    ...(ReactDOM?.createRoot ? { ReactDOMClient: ReactDOM } : { ReactDOM }),
    rootComponent: LazyRootCmp,
    errorBoundary(err, errInfo) {
        console.error('cloud-main: unhandled error', err, errInfo);
        return <>Single Spa Error</>;
    },
});

const loadRuntimeVariables = (onload: (value: unknown) => void) =>
    appendScript({
        src: `${window._env_.MAIN_UI}/static/env-vars.js`,
        onload,
    } as React.ScriptHTMLAttributes<HTMLScriptElement>);

function bootstrap(...args: Parameters<typeof bootstrapOriginal>) {
    return new Promise(loadRuntimeVariables).then(() => bootstrapOriginal(...args));
}

export { bootstrap, unmount, mount };
